import * as service from './service'
export default {
  namespace: 'equipmentMallMallDetail',
  state: {
    saleData: {}
  },
  effects: {
    * getSaleDetail ({ payload }, { call, put }) {
      const res = yield call(service.getSaleDetail, payload)
      yield put({
        type: 'save',
        payload: {
          saleData: res.data
        }
      })
      return res.data
    },
    * checkStock ({ payload, bizCodeHandler, bizCodes }, { call, put }) {
      const res = yield call(service.checkStock, payload, bizCodeHandler, bizCodes)
      yield put({
        type: 'save',
        payload: {
          saleData: res.data
        }
      })
      return res.data
    },
    * getSpuParamStock ({ payload }, { call, put }) {
      const res = yield call(service.getSpuParamStock, payload)
      return res.data
    },
    * getSalePrices ({ payload }, { call, put }) {
      const res = yield call(service.getSalePrices, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
